/**
 * On 2026-09-04 the legacy Eligibility Portal is decommissioned in favor of the Garner Admin Portal.
 * From that date forward, every visit to eligibility.getgarner.com immediately redirects to the new
 * portal (see redirect-view.component.tsx).
 *
 * The cutoff is evaluated in the visitor's local time: `new Date(2026, 8, 4)` is local midnight on
 * September 4 (month is 0-indexed, so 8 = September). Each user is redirected once it becomes 9/4
 * in their own time zone, rather than at a single global instant.
 */
export const DECOMMISSION_DATE = new Date(2026, 8, 4);

/**
 * Query param that forces the redirect regardless of the date, e.g. `?redirect-preview`. Lets us
 * verify the redirect flow locally and in dev/staging before the cutoff date arrives.
 */
export const REDIRECT_PREVIEW_PARAM = 'redirect-preview';

/** Whether the legacy portal is decommissioned as of `now` (defaults to the current local time). */
export const isDecommissioned = (now: Date = new Date()): boolean => now.getTime() >= DECOMMISSION_DATE.getTime();

/**
 * Whether a visitor should be redirected to the Garner Admin Portal: true once the portal is
 * decommissioned, or whenever the preview override is present in the URL query string.
 */
export const shouldRedirect = (
  now: Date = new Date(),
  search: string = typeof window === 'undefined' ? '' : window.location.search,
): boolean => isDecommissioned(now) || new URLSearchParams(search).has(REDIRECT_PREVIEW_PARAM);
